import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiPatch, apiPostQuery } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const queryEmployees = async (token, municipalityId, params) => {
  const url = `municipalities/${municipalityId}/employees/query`

  const data = await apiPostQuery({ url, token, params })
  return data
}

export function useEmployees({ params, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => queryEmployees(token, municipality_id, params)
  const queryKey = ['employees', params]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const getEmployee = async (token, params) => {
  const url = `employees/${params.id}`

  const data = await apiGet({ url, token, params })
  return data
}

export function useEmployee({ params, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getEmployee(token, params)
  const queryKey = ['employee', params]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const updateEmployee = async (token, params) => {
  const objectName = 'employee'
  const url = `employees/${params.id}`
  const data = await apiPatch({ url, token, objectName, params })
  return data
}

export function useUpdateEmployee({ options } = {}) {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    ({ params }) => updateEmployee(token, params),
    {
      onSuccess: (_data, variables) => {
        if (variables?.params?.id) {
          queryClient.invalidateQueries(['employee', { id: variables.params.id }])
        }
      },
      ...options
    }
  )
}
